import { SkyBoxRoutesEnum } from "models/enums/apiRoutes/skyBoxApiRoutes";
import { ListingReportData } from "models/interfaces";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import { listingType } from "models/types";
import axiosClient from "sharedServices/api/axios.services";

class ListingService {
    public getListingData = async (listingRequest: listingType) => {
        return axiosClient.get<
            IApiBaseResponse<ListingReportData>
        >(SkyBoxRoutesEnum.LISTING, {
            params: listingRequest
        });
    };
}

export { ListingService };
